
































import {
  computed, defineComponent, Ref, ref,
} from '@vue/composition-api';
import { LoremIpsum } from 'lorem-ipsum';
import useHandleDrawer from '@/components/composers/useHandleDrawer';

const InfoSidebar: object = defineComponent({
  name: 'InfoSidebar',
  setup() {
    const lorem = new LoremIpsum({
      sentencesPerParagraph: {
        max: 8,
        min: 4,
      },
      wordsPerSentence: {
        max: 16,
        min: 4,
      },
    });

    const selectedPageId: Ref<number> = ref(1);

    const pages: Ref<Array<object>> = ref([
      { id: 1, title: lorem.generateSentences(1), content: lorem.generateParagraphs(4) },
      { id: 2, title: lorem.generateSentences(1), content: lorem.generateParagraphs(4) },
      { id: 3, title: lorem.generateSentences(1), content: lorem.generateParagraphs(4) },
      { id: 4, title: lorem.generateSentences(1), content: lorem.generateParagraphs(4) },
    ]);

    const getSelectedPage = computed(() => {
      const page: any = pages.value.find((element: any) => element.id === selectedPageId.value);
      page.content = page.content.replace('\n', '<br>');
      return page;
    });

    return {
      pages,
      selectedPageId,
      getSelectedPage,
      ...useHandleDrawer(),
    };
  },
});
export default InfoSidebar;
